import { jwtDecode } from 'jwt-decode';

import { InputValidationType, User } from './type';

export const emailChecker = (input: string): InputValidationType => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const valid = regex.test(input);

  return {
    message: valid ? null : 'Email is incorrect',
    isValid: valid ? true : false,
    input: valid ? String(input).toLowerCase() : null,
  };
};

export const decodeToken = (token: string) => {
  return jwtDecode<Omit<User, 'password'>>(token);
};

export const passwordChecker = (password: string): InputValidationType => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  if (password.length < minLength) {
    return {
      message: 'Password must be at least 8 characters long',
      isValid: false,
      input: null,
    };
  }

  if (!hasUpperCase) {
    return {
      message: 'Password must contain at least one uppercase letter',
      isValid: false,
      input: null,
    };
  }

  if (!hasLowerCase) {
    return {
      message: 'Password must contain at least one lowercase letter',
      isValid: false,
      input: null,
    };
  }

  if (!hasNumbers) {
    return {
      message: 'Password must contain at least one number',
      isValid: false,
      input: null,
    };
  }

  if (!hasSpecialChar) {
    return {
      message: 'Password must contain at least one special character',
      isValid: false,
      input: null,
    };
  }

  return {
    message: null,
    isValid: true,
    input: password,
  };
};

// Try to get the Facebook Pixel ID from runtime env first, then fallback to build-time env
export const getFacebookPixelId = () => {
  // Check if window._env_ exists (created by env.sh in production)
  if (
    typeof window !== 'undefined' &&
    window._env_ &&
    window._env_.VITE_FACEBOOK_PIXEL_ID
  ) {
    return window._env_.VITE_FACEBOOK_PIXEL_ID;
  }
  // Fallback to build-time env variable
  return import.meta.env.VITE_FACEBOOK_PIXEL_ID;
};

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
